import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.6 Case 6</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_106"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number 106. This is a positive
                case. Beginning in the inferior aspect of the brain, at the
                level of the temporal and occipital regions, it is immediately
                clear that the white matter tracts are not easily identifiable
                within the temporal and occipital lobe on the right-hand side.
                There is loss of gray-white contrast on the right. On the left,
                this finding is even more dramatic, as there is intense uptake
                within the gray matter of the temporal lobe. This activity
                exceeds that of the activity in the adjacent white matter,
                located here. As always, it is important to review the slices
                immediately superior to ensure that these findings are not an
                anomaly. And as we scroll superiorly, in fact, we can see that
                there is loss of gray-white contrast throughout the temporal and
                occipital regions on multiple slices. In addition, there is
                continued intense uptake in the gray matter in the left temporal
                lobe on multiple slices. Therefore, this scan is already
                positive based on the abnormalities seen in the temporal and
                occipital lobes. However, as we continue to review the remainder
                of the scan and we enter into the frontal lobes, located here,
                we can again see that there is loss of gray-white contrast on
                the left-hand side, seen here, as well as on the right-hand
                side, seen here. White matter tracts are not clearly
                identifiable at this level. And as we move superiorly, this
                pattern continues. At this level we also see the parietal lobes.
                And in the posterior parietal region, there continues to be loss
                of gray-white contrast, seen on the right-hand side here, as well
                as on the left-hand side, located here. In addition, on the
                left-hand side, a small area of focal uptake located within the
                gray matter is also seen. Therefore, once again, there is loss
                of gray-white contrast throughout the parietal region. As we
                continue to move superiorly and enter into the medial parietal
                region, increased activity is seen within the gray matter of the
                precuneus, located here. Therefore, this scan is positive, as
                there are multiple regions with loss of gray-white contrast.
                Moving to the coronal images, one can also see that there is
                loss of gray-white contrast within the left temporal region,
                located here. In fact, increased activity is seen extending to
                the periphery in this region. If you called this case negative,
                please review the scan once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-5"
          nextLesson="/module-3/module-3-0-7"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2081829373&entry_id=1_fimy80ly&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_fimy80ly"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
